/*
     1. Take the string
     2. The string is the default.
     3. It can be overridden by:
     - a generic translation
     - a specific label set by the owner
     */
angular.module('calendarApp').filter('calendarLabel', calendarLabel);

function calendarLabel() {
  return function (label) {
    return smooth.translations && smooth.translations[label] || label;
  };
}